
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/user360",
      function () {
        return require("private-next-pages/products/user360.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/user360"])
      });
    }
  